import { useRef } from 'react';
import { isEmpty } from 'lodash';
import type { JWTUser } from '@types';
import {
  clearAuthData,
  logout as authLogout,
  getJwtUserData,
  setJwtUserData,
  verifyUserRefreshData,
} from '@/utils/auth/auth';

const useIsLoggedIn = (queryString: string) => {
  const params = new URLSearchParams(queryString);
  const redirectUrl = params.get('redirectUrl') || '/';
  const isVerified = useRef<boolean>(false);

  const { expiresIn, user: verifiedUser } = getJwtUserData();
  let user: JWTUser | null = null;
  // Logged-in signal is the persisted User object; the access token is no longer
  // stored client-side (it is an httpOnly cookie).
  if (!isEmpty(verifiedUser)) {
    if (!isVerified.current) {
      user = {
        ...verifiedUser,
      };
      isVerified.current = true;
    }
  }
  const logout = async () => {
    await authLogout();
    isVerified.current = false;
    clearAuthData();
  };
  const updateDelegationStatus = (delegationStatus: boolean) => {
    user = {
      ...verifiedUser,
      delegatedPermissionsActive: delegationStatus,
    };
    setJwtUserData(user);

    localStorage.setItem('User', JSON.stringify(user));
  };

  const authenticationRefreshed = localStorage.getItem(
    'authentication_refreshed'
  );

  return {
    isVerified: isVerified.current,
    redirectUrl,
    User: user,
    expiresIn: new Date(expiresIn),
    setJwtUserData,
    getJwtUserData,
    logout,
    updateDelegationStatus,
    verifyUserAuthRefreshData: verifyUserRefreshData,
    authenticationRefreshed,
  };
};

export default useIsLoggedIn;
